import { Outlet, createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/study")({
  component: StudyLayout,
})

function StudyLayout() {
  return <Outlet />
}
